export default "__VITE_ASSET__Ds6MU0ms__"